import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/room-meeting-management";

export interface listType {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};


export class RoomMeetingManagementApi extends BaseAPI {
  static getRoomMeetingList(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getRoomMeetingById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createRoomMeeting(body: FormData): Promise<any> {
    return this.api.post(`${path}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static addEquipmentToRoomMeeting(
    id_room_meeting: number,
    body: any
  ): Promise<any> {
    return this.api.post(`${path}/${id_room_meeting}/add-equipment`, body);
  }

  static updateEquipmentToRoomMeeting(
    id_room_meeting_equipment: number,
    body: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/update-equipment/${id_room_meeting_equipment}`,
      body
    );
  }

  static deleteEquipmentToRoomMeeting(
    id_room_meeting_equipment: number
  ): Promise<any> {
    return this.api.delete(
      `${path}/delete-equipment/${id_room_meeting_equipment}`
    );
  }

  static updateRoomMeeting(id: number, body: FormData): Promise<any> {
    return this.api.post(`${path}/update/${id}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static deleteRoomMeeting(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static updateStatusPublic(id_room_meeting: number): Promise<AxiosResponse> {
    return this.api.patch(`${path}/${id_room_meeting}/update-public`);
  }
}
